export default [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    timezone: 'CST',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    timezone: 'AKST',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
    timezone: 'ST',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    timezone: 'MST',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    timezone: 'CST',
  },
  {
    name: 'California',
    abbreviation: 'CA',
    timezone: 'PST',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    timezone: 'MST',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    timezone: 'EST',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    timezone: 'EST',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
    timezone: 'MST',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
    timezone: 'MST',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    timezone: 'EST',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    timezone: 'EST',
  },
  {
    name: 'Guam Gu',
    abbreviation: 'GU',
    timezone: 'UTC+10',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    timezone: 'HST',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    timezone: 'MST',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    timezone: 'CST',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    timezone: 'EST',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    timezone: 'CST',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    timezone: 'CST',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    timezone: 'CST',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    timezone: 'CST',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    timezone: 'EST',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
    timezone: 'EST',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    timezone: 'EST',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    timezone: 'EST',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    timezone: 'EST',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    timezone: 'CST',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    timezone: 'CST',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    timezone: 'CST',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    timezone: 'MST',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    timezone: 'CST',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    timezone: 'PST',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    timezone: 'EST',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    timezone: 'EST',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    timezone: 'MST',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    timezone: 'EST',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    timezone: 'EST',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    timezone: 'CST',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
    timezone: 'UTC+10',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    timezone: 'EST',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    timezone: 'CST',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    timezone: 'PST',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
    timezone: 'MST',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    timezone: 'EST',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
    timezone: 'ATC',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    timezone: 'EST',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    timezone: 'EST',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    timezone: 'EST',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    timezone: 'CST',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    timezone: 'CST',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    timezone: 'MST',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    timezone: 'EST',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
    timezone: 'ATC',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    timezone: 'EST',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    timezone: 'PST',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    timezone: 'EST',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    timezone: 'CST',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    timezone: 'MST',
  },
]
